import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    setIsNavOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-L2E sticky-top">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="assets/website/img/logo-2.png" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsNavOpen((prev) => !prev)}
          >
            <span className="navbar-toggler-icon" />
            <span className="navbar-toggler-icon-2" />
            <span className="navbar-toggler-icon-3" />
          </button>
          <div
            className={`collapse navbar-collapse justify-content-end${isNavOpen ? " show" : ""}`}
            id="L2ENav"
          >
            <ul className="navbar-nav align-items-lg-center cus-mobile-bar">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" end>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about">
                  About
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/all_courses"
                  id="coursesDD"
                  role="button"
                  data-toggle="dropdown"
                >
                  Courses
                </Link>
                <div className="dropdown-menu" aria-labelledby="coursesDD">
                  <Link className="dropdown-item" to="/all_courses">
                    All Courses
                  </Link>
                  <Link className="dropdown-item" to="/master_courses">
                    Master Course
                  </Link>

                  <Link className="dropdown-item" to="/weekend_courses">
                    Weekend Crash Course
                  </Link>
                </div>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/gallery">
                  Gallery
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/blogs">
                  Blogs
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/faqs">
                  FAQs
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">
                  Contact
                </NavLink>
              </li>
              <li className="nav-item ml-lg-2">
                <Link className="nav-cta" to="/panel/login">
                  Sign In / Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
